
<div class="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50" *ngIf="isOpen">
  <div class="bg-white p-6 rounded-2xl shadow-lg w-96 relative">
    <!-- Close Button -->
    <button class="absolute top-3 right-3 text-gray-400 hover:text-gray-600" (click)="close()">✖</button>

    <!-- Conditional UI -->
    <ng-container *ngIf="!isFileProcessed; else downloadSection">
      <!-- Title -->
      <h2 class="text-lg font-semibold text-center text-gray-600">Upload Sample File</h2>

      <!-- Tailwind Drag & Drop File Upload -->
      <div class="flex items-center justify-center w-full mt-4">
        <label for="dropzone-file" class="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition">
          <div class="flex flex-col items-center justify-center pt-5 pb-6">
            <svg class="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
            </svg>
            <p class="mb-2 text-sm text-gray-500"><span class="font-semibold">Click to upload</span> or drag and drop</p>
            <p class="text-xs text-gray-500">CSV only (Max 5MB)</p>
          </div>
          <input id="dropzone-file" type="file" class="hidden" (change)="onFileSelected($event)" accept=".csv"/>
        </label>
      </div>

      <!-- File Name -->
      <p class="mt-2 text-sm text-gray-600 text-center">{{ selectedFileName || 'No file selected' }}</p>

      <!-- Submit Button -->
      <button
        class="mt-4 w-full primary-bg text-white py-2 rounded-lg font-medium primary-hover transition flex items-center justify-center"
        (click)="submitFile()"
        [disabled]="isLoading">
        <span *ngIf="!isLoading">Submit</span>
        <span *ngIf="isLoading">Processing...</span>
      </button>
    </ng-container>

    <!-- Download & Upload Another File Section -->
    <ng-template #downloadSection>
      <h2 class="text-lg font-semibold text-center text-gray-500">File Processed ✅</h2>

      <!-- Download Config File -->
      <a *ngIf="jsonDownloadUrl" [href]="jsonDownloadUrl" download="config.json"
        class="mt-4 w-full primary-bg text-white py-2 rounded-lg font-medium primary-hover transition block text-center">
        Download Config File
      </a>

      <!-- Subtle "Upload Now" Link -->
      <p class="mt-4 text-md font-semibold w-fit text-[#1d4e8a] mx-auto px-3 py-1 rounded-md text-center cursor-pointer
      hover:text-[#465d79] hover:brightness-125 hover:scale-105 transition duration-300 animate-glow"
      (click)="uploadtrigger()">
      → Upload Modified Config File
      </p>

      <!-- Upload Another Sample File (Outlined Button) -->
      <button class="mt-4 w-40 border text-[12px] border-gray-400 text-gray-600 py-1.5 px-4 rounded-md font-medium hover:bg-gray-100 transition mx-auto block"
      (click)="resetUploadState()">
        Upload Another Sample File
      </button>

    </ng-template>
    <!-- Skip Link -->
    <p class="mt-3 text-right text-blue-500 text-sm cursor-pointer " (click)="close()">Skip »</p>
  </div>
</div>
